module.exports = __webpack_public_path__ + "img/thalia-logo.fc04bf02.svg";